module.exports = __webpack_public_path__ + "img/cq3d-title-icon.92090ca5.png";